export const SET_PROMOTION = 'SET_PROMOTION';
export const SET_IS_LOADING_PROMOTIONS = 'SET_IS_LOADING_PROMOTIONS';
export const SET_TOKEN_FOR_CREDIT_LINE = 'SET_TOKEN_FOR_CREDIT_LINE';
export const SET_TOKEN_FOR_CREDIT_WITH_ACCOUNT = 'SET_TOKEN_FOR_CREDIT_WITH_ACCOUNT';
export const SET_TOKEN_FOR_INSTALLMENT_CREDIT = 'SET_TOKEN_FOR_INSTALLMENT_CREDIT';
export const SET_IS_LOADING_CREDIT_LINE_TOKEN = 'SET_IS_LOADING_CREDIT_LINE_TOKEN';
export const SET_IS_LOADING_CREDIT_WITH_ACCOUNT_TOKEN = 'SET_IS_LOADING_CREDIT_WITH_ACCOUNT_TOKEN';
export const SET_IS_LOADING_INSTALLMENT_CREDIT_TOKEN = 'SET_IS_LOADING_INSTALLMENT_CREDIT_TOKEN';
